import React, { useEffect, useState, useRef, useMemo, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import {
  Button,
  LinearProgress,
  Tooltip,
  TooltipProps,
  linearProgressClasses,
  tooltipClasses,
} from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';
import RecruitChart from './recruit-chart';

import Color from '@tool/color';
import { CloseIcon20, UpChangeIcon, DownChangeIcon } from '@styled/icon';
import { newRate } from '@tool/index';
import moRival, { changeActive, toggleSetModel } from '../../store/rival';
import moUser from '@/store/user';
import NonAuth from '../../salary/non-auth';
import Empty from '@/component/empty';

interface IProps {}
interface IState {}

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} placement="top" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    padding: '10px 20px',
    '& p': {
      color: Color.white,
      display: 'flex',
      justifyContent: 'space-between',
      width: '200px',
      lineHeight: '34px',
      fontWeight: 600,
      '& label': {
        fontFamily: 'Mont SemiBold',
      },
      '& span': {
        color: Color.whiteColor(0.7),
      },
    },
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
}));

const Recruitment = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { activeComapny, companyList, rivalList } = moRival;
  const { isLogin } = moUser;

  const goRecruit = (ev: MouseEvent) => {
    ev.stopPropagation();
    window.location.href = '/market/insight?key=label411';
  };

  const goNumber = (ev: MouseEvent) => {
    ev.stopPropagation();
    window.location.href = '/market/insight?key=label111';
  };

  const goType = (ev: MouseEvent) => {
    ev.stopPropagation();
    window.location.href = '/market/insight?key=label211';
  };

  const goCity = (ev: MouseEvent) => {
    ev.stopPropagation();
    window.location.href = '/market/insight?key=label311';
  };

  const goDevelop = (ev: MouseEvent) => {
    ev.stopPropagation();
    window.location.href = '/market/insight?key=label411';
  };

  const getResult = useMemo(() => {
    let data: any = {};
    rivalList?.forEach((ele: any) => {
      if (ele.company_name === activeComapny) {
        data = ele;
      }
    });
    return data;
  }, [rivalList, activeComapny]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="dash-effect-warp">
      {isLogin ? (
        <section className="dash-industry-content">
          <section className="top">
            <h3>对标企业招聘动态</h3>
            <section className="check">
              {companyList.map((res: any, r: any) => {
                return (
                  <a
                    key={r}
                    className={res === activeComapny ? 'active' : ''}
                    onClick={() => {
                      changeActive(res);
                    }}>
                    {res}
                  </a>
                );
              })}
            </section>
            <p
              onClick={() => {
                toggleSetModel(true);
              }}>
              {moUser.isDataBoardExpired && '+ 我的对标企业'}
            </p>
          </section>
          <section className="contents">
            <section className="left dash-move" onClick={goRecruit}>
              <h4>近一年企业招聘趋势</h4>
              <RecruitChart />
            </section>
            <section className="mid dash-move" onClick={goNumber}>
              <h4>
                近一个月招聘量
                {/* &nbsp;<span>new</span> */}
              </h4>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <p>
                      <span>公司</span>
                      <b>{activeComapny}</b>
                    </p>
                    <p>
                      <span>时间</span>
                      <label>近一个月</label>
                    </p>
                  </React.Fragment>
                }>
                <b>
                  {getResult?.recent_recruit_amount?.amount_current ?
                    getResult?.recent_recruit_amount?.amount_current.toLocaleString() :
                    '-'}
                </b>
              </HtmlTooltip>

              <section className="change-radio">
                <a>较上期变化</a>
                {getResult?.recent_recruit_amount?.amount_change_rate ||
                getResult?.recent_recruit_amount?.amount_change_rate === 0 ? (
                    <span>
                      {getResult?.recent_recruit_amount?.amount_change_rate >=
                    0 ? (
                          <UpChangeIcon />
                        ) : (
                          <DownChangeIcon />
                        )}
                    &nbsp;
                      <i
                        style={{
                          color:
                          getResult?.recent_recruit_amount
                            ?.amount_change_rate >= 0 ?
                            Color.red :
                            Color.success,
                        }}>
                        {round(
                          Math.abs(
                            getResult?.recent_recruit_amount?.amount_change_rate,
                          ) * 100,
                          1,
                        )}
                      %
                      </i>
                    </span>
                  ) : (
                    '-'
                  )}
              </section>
            </section>
            <section className="special dash-move" onClick={goType}>
              <h4>
                人才需求类型
                {/* &nbsp;<span>new</span> */}
              </h4>
              {!isEmpty(getResult?.recruit_category) ? (
                <section className="type-items">
                  {getResult?.recruit_category?.map((res: any, r: any) => {
                    return (
                      <section
                        className={
                          r === 0 && getResult?.recruit_category.length > 2 ?
                            'item' :
                            ''
                        }
                        key={r}>
                        <span>
                          <i
                            style={{
                              color:
                                res.amount_change_rate >= 0 ?
                                  Color.red :
                                  Color.success,
                            }}>
                            {res.amount_change_rate ||
                            res.amount_change_rate === 0 ?
                              `${round(res.amount_change_rate * 100, 1)}%` :
                              '-'}
                          </i>
                          <label>{res.category_name}</label>
                        </span>
                      </section>
                    );
                  })}
                </section>
              ) : (
                <Empty height="auto" />
              )}
            </section>
            <section className="special dash-move" onClick={goCity}>
              <h4>
                城市布局
                {/* &nbsp;<span>new</span> */}
              </h4>
              {!isEmpty(getResult?.recruit_city) ? (
                <section className="type-items">
                  {getResult?.recruit_city?.map((res: any, r: any) => {
                    return (
                      <section
                        className={
                          r === 0 && getResult?.recruit_city.length > 2 ?
                            'item' :
                            ''
                        }
                        key={r}>
                        <span>
                          <i
                            style={{
                              color:
                                res.amount_change_rate >= 0 ?
                                  Color.red :
                                  Color.success,
                            }}>
                            {res.amount_change_rate ||
                            res.amount_change_rate === 0 ?
                              `${round(res.amount_change_rate * 100, 1)}%` :
                              '-'}
                          </i>
                          <label>{res.city_name}</label>
                        </span>
                      </section>
                    );
                  })}
                </section>
              ) : (
                <Empty height="auto" />
              )}
            </section>
            <section className="mid dash-move" onClick={goDevelop}>
              <h4>
                发展趋势
                {/* &nbsp;<span>new</span> */}
              </h4>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <p>
                      <span>公司</span>
                      <b>{activeComapny}</b>
                    </p>
                    <p>
                      <span>时间</span>
                      <label>近一个月</label>
                    </p>
                  </React.Fragment>
                }>
                <b>
                  {getResult?.recruit_trend_overview?.change_rate ||
                  getResult?.recruit_trend_overview?.change_rate === 0 ?
                    `${round(
                      getResult?.recruit_trend_overview?.change_rate * 100,
                      1,
                    )}%` :
                    '-'}
                </b>
              </HtmlTooltip>
              <section className="change-radio">
                <a>招聘量近1年</a>
                <label>{getResult?.recruit_trend_overview?.tag ?? '-'}</label>
              </section>
            </section>
          </section>
        </section>
      ) : (
        <NonAuth />
      )}
      {moUser.isDataBoardExpired && (
        <section className="position-title">
          特定企业数据 - 开通会员，支持指定对比企业
        </section>
      )}
    </section>
  );
};

export default observer(Recruitment);
